import { Card, ConfigProvider, Flex, Typography } from 'antd';
import { DARK, DMS_TYPE, HYPHEN } from '../../../utilities/constants';
import PropTypes from 'prop-types';
import { getFormattedDateTimeFromTimestamp } from '../../../utilities/commonFunctions';
import { useTheme } from '../../../context/ThemeContext';

const { Text } = Typography;

const AnomalyCard = ({ details, anomalyColor }) => {
  const { theme } = useTheme();
  const getAnomalyText = type => {
    if (type === 'sos') {
      return 'SOS';
    } else if (type === 'rash_driving') {
      return 'Rash Driving';
    } else if (type === DMS_TYPE.DROWSINESS) {
      return 'Driver Drowsiness';
    } else if (type === DMS_TYPE.DISTRACTION) {
      return 'Driver Distraction';
    } else if (type === 'door_open') {
      return 'Door Open';
    } else if (type === 'overspeed') {
      return 'Over Speeding';
    }
  };

  return (
    <ConfigProvider
      theme={{
        components: {
          Card: {
            padding: 0,
            paddingLG: 0,
            colorBorderSecondary: theme === DARK ? '#2E3033' : '#C1C7CC',
            colorBgContainer: theme === DARK ? '#2E3033' : '#E0E2E5',
            borderRadiusLG: 0,
            boxShadowTertiary: 'none',
          },
        },
      }}
    >
      <Card
        style={{ borderLeft: `4px solid ${anomalyColor}` }}
        className="anomaly-card"
      >
        <Flex vertical gap={8}>
          <Flex
            justify="space-between"
            wrap="wrap"
            gap={8}
            style={
              details?.type === 'sos' || details?.type === 'dms_drowsy'
                ? {}
                : { marginLeft: '4px' }
            }
          >
            <Text strong style={{ color: anomalyColor }}>
              {getAnomalyText(details?.type)}
            </Text>
            <Text>
              {getFormattedDateTimeFromTimestamp(details?.timestamp) || HYPHEN}
            </Text>
          </Flex>
          {details?.ticket_status &&
          (details?.type === 'sos' || details?.type === 'dms_drowsy') ? (
            <Text>{`Status: ${details.ticket_status || HYPHEN}`}</Text>
          ) : null}
        </Flex>
      </Card>
    </ConfigProvider>
  );
};

AnomalyCard.propTypes = {
  details: PropTypes.object,
  anomalyColor: PropTypes.string,
};

export default AnomalyCard;
